import { pgTable, primaryKey, text, boolean, foreignKey, uuid, } from 'drizzle-orm/pg-core';
import { sortOrder, tableBase } from '../utils';
import { MetricType, RecordType, TagType } from '../enums';
import { metricConfigDefaults } from '../json/metrics';
import { configColumn } from '../json';
export const AdminBodyPart = pgTable('admin_body_part', {
    ...tableBase,
    name: text('name').notNull(),
}, (table) => ({
    pk: primaryKey({
        columns: [table.id],
    }),
}));
export const AdminEquipment = pgTable('admin_equipment', {
    ...tableBase,
    name: text('name').notNull(),
}, (table) => ({
    pk: primaryKey({
        columns: [table.id],
    }),
}));
export const AdminExerciseMetric = pgTable('admin_exercise_metric', {
    ...tableBase,
    sortOrder,
    name: text('name').notNull(),
    type: MetricType('type').notNull(),
    isCollectable: boolean('is_collectable').notNull().default(true),
    config: configColumn('config', metricConfigDefaults).notNull(),
    recordType: RecordType('record_type'),
}, (table) => ({
    pk: primaryKey({
        columns: [table.id],
    }),
}));
export const AdminTrainingFocus = pgTable('admin_training_focus', {
    ...tableBase,
    name: text('name').notNull(),
    trainingTypeId: uuid('training_type_id').notNull(),
}, (table) => ({
    pk: primaryKey({
        columns: [table.id],
    }),
    typeFk: foreignKey({
        columns: [table.trainingTypeId],
        foreignColumns: [AdminTrainingType.id],
    }),
}));
export const AdminTrainingType = pgTable('admin_training_type', {
    ...tableBase,
    name: text('name').notNull(),
}, (table) => ({
    pk: primaryKey({
        columns: [table.id],
    }),
}));
export const AdminTag = pgTable('admin_tag', {
    ...tableBase,
    name: text('name').notNull(),
    color: text('color').notNull(),
    type: TagType('type').notNull(),
}, (table) => ({
    pk: primaryKey({
        columns: [table.id],
    }),
}));
//# sourceMappingURL=misc.js.map